export const manufacturers = [
    { id: 1, name: 'Grifon', count: 56 },
    { id: 2, name: 'Boyscout', count: 66 },
    { id: 3, name: 'Paclan', count: 166 },
    { id: 4, name: 'Булгари Грин', count: 21 },
    { id: 5, name: 'Нэфис', count: 45 },
    { id: 6, name: 'AOS', count: 34 },
    { id: 7, name: 'BIMAX', count: 28 },
    { id: 8, name: 'Sorti', count: 52 },
    { id: 9, name: 'Grifon Pro', count: 15 },
    { id: 10, name: 'Boyscout Premium', count: 23 },
];
